export default __webpack_public_path__ + "f7346e9b478a5ef6043bcfd5a5e04922.png";